export default "__VITE_ASSET__624c4650__"